import React from 'react';
import PropTypes from 'prop-types';
import {
  Activity,
  AlarmClock,
  AlertTriangle,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  BadgeCheck,
  BarChart3,
  BatteryCharging,
  Bell,
  BellOff,
  Book,
  BookOpen,
  BookOpenCheck,
  Bot,
  Box,
  Brain,
  Briefcase,
  Bug,
  Calendar,
  Check,
  CheckCircle2,
  ChartLine,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ClipboardList,
  Clock3,
  Cog,
  Cloud,
  Compass,
  CreditCard,
  Database,
  Download,
  Edit3,
  Eye,
  EyeOff,
  FileText,
  Fingerprint,
  Flame,
  FlaskConical,
  FlaskRound,
  FolderOpen,
  Gauge,
  Gift,
  GitMerge,
  Globe2,
  GraduationCap,
  Gem,
  HardDrive,
  HandHeart,
  Heart,
  HelpCircle,
  History,
  Home,
  Info,
  Infinity,
  Key,
  Laptop,
  Leaf,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  Lightbulb,
  ListChecks,
  Loader2,
  Lock,
  Mail,
  Map,
  MapPin,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Menu,
  Monitor,
  Moon,
  Notebook,
  Octagon,
  Palette,
  Pause,
  PauseCircle,
  Pen,
  PieChart,
  Pin,
  Plus,
  Package,
  RefreshCw,
  Repeat2,
  Rocket,
  Route,
  Ruler,
  Rss,
  Scale,
  Search,
  Settings,
  Shield,
  ShieldCheck,
  Shuffle,
  Sparkles,
  Sprout,
  Star,
  Smartphone,
  Sun,
  Table,
  Target,
  Trash2,
  TrendingDown,
  TrendingUp,
  Upload,
  User,
  Users,
  Wifi,
  WifiOff,
  Wand2,
  Wrench,
  X,
  Zap
} from 'lucide-react';

const ICON_COMPONENTS = {
  activity: Activity,
  'arrow-left': ArrowLeft,
  'arrow-left-right': ArrowLeftRight,
  'arrow-right': ArrowRight,
  'alarm-clock': AlarmClock,
  'alert-triangle': AlertTriangle,
  'badge-check': BadgeCheck,
  'bar-chart-3': BarChart3,
  'battery-charging': BatteryCharging,
  bell: Bell,
  'bell-off': BellOff,
  bug: Bug,
  book: Book,
  'book-open': BookOpen,
  'book-open-check': BookOpenCheck,
  bot: Bot,
  box: Box,
  brain: Brain,
  briefcase: Briefcase,
  calendar: Calendar,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  check: Check,
  'check-circle-2': CheckCircle2,
  'check-circle': CheckCircle2,
  chart: ChartLine,
  'clipboard-list': ClipboardList,
  'clock-3': Clock3,
  cog: Cog,
  cloud: Cloud,
  compass: Compass,
  'credit-card': CreditCard,
  database: Database,
  download: Download,
  'edit-3': Edit3,
  eye: Eye,
  'eye-off': EyeOff,
  'file-text': FileText,
  fingerprint: Fingerprint,
  flame: Flame,
  flask: FlaskRound,
  'flask-conical': FlaskConical,
  'folder-open': FolderOpen,
  gift: Gift,
  gem: Gem,
  gauge: Gauge,
  'git-merge': GitMerge,
  'globe-2': Globe2,
  globe: Globe2,
  'graduation-cap': GraduationCap,
  'hard-drive': HardDrive,
  'hand-heart': HandHeart,
  heart: Heart,
  'help-circle': HelpCircle,
  history: History,
  home: Home,
  info: Info,
  infinity: Infinity,
  key: Key,
  laptop: Laptop,
  leaf: Leaf,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  'life-buoy': LifeBuoy,
  lightbulb: Lightbulb,
  'list-checks': ListChecks,
  loader: Loader2,
  'loader-2': Loader2,
  lock: Lock,
  mail: Mail,
  map: Map,
  'map-pin': MapPin,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  'messages-square': MessagesSquare,
  menu: Menu,
  monitor: Monitor,
  moon: Moon,
  notebook: Notebook,
  octagon: Octagon,
  palette: Palette,
  pause: Pause,
  'pause-circle': PauseCircle,
  pen: Pen,
  'pie-chart': PieChart,
  pin: Pin,
  plus: Plus,
  package: Package,
  repeat: Repeat2,
  'refresh-cw': RefreshCw,
  rocket: Rocket,
  route: Route,
  ruler: Ruler,
  rss: Rss,
  scale: Scale,
  search: Search,
  settings: Settings,
  shield: Shield,
  'shield-check': ShieldCheck,
  shuffle: Shuffle,
  sparkles: Sparkles,
  star: Star,
  smartphone: Smartphone,
  sprout: Sprout,
  sun: Sun,
  table: Table,
  target: Target,
  'trash-2': Trash2,
  'trending-down': TrendingDown,
  'trending-up': TrendingUp,
  upload: Upload,
  user: User,
  users: Users,
  wifi: Wifi,
  'wifi-off': WifiOff,
  'wand-2': Wand2,
  wrench: Wrench,
  x: X,
  zap: Zap
};

const Icon = ({ name, size = 20, color = 'currentColor', strokeWidth = 1.6, className = '', ...rest }) => {
  const IconComponent = ICON_COMPONENTS[name] || ICON_COMPONENTS.info;
  if (!IconComponent) return null;

  return (
    <IconComponent
      aria-hidden="true"
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      focusable="false"
      {...rest}
    />
  );
};

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(ICON_COMPONENTS)).isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string
};

export default Icon;
